import OQProducerRoutes from "@/router/open_queries/producers.js";
import OQOrganizationRoutes from "./organization/index.js";
import OQPackingHouseRoutes from "@/router/open_queries/packing_house.js";
import OQAgroexporterRoutes from "@/router/open_queries/agroexporter.js";
import OQCustomerRoutes from "@/router/open_queries/customers.js";

export default [
  ...OQProducerRoutes,
  ...OQOrganizationRoutes,
  ...OQPackingHouseRoutes,
  ...OQAgroexporterRoutes,
  ...OQCustomerRoutes
];
